document.addEventListener('DOMContentLoaded', () => {
  // ------------------------------------------------
  // 1. Swiperの設定
  // ------------------------------------------------
  if (document.querySelector('.page-event-product')) {
    new Swiper('.page-event-product', {
      loop: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      spaceBetween: 10,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  }

  // ------------------------------------------------
  // 2. 背景画像のスクロール連動切り替え
  // ------------------------------------------------
  
  const bgWrap = document.querySelector('.page-event-content__bg-img');
  const bgImages = document.querySelectorAll('.page-event-content__bg-img img');
  const mainContent = document.querySelector('.page-event-lp'); 

  // 要素が存在しないページではエラーを防ぐために処理を終了
  if (!bgWrap || bgImages.length === 0 || !mainContent) return;

  // 設定値
  const triggerLine = window.innerHeight / 2; // 画像が切り替わる判定ライン（画面中央）
  const BG_END_OFFSET = 0; // 全体が消えるタイミングの調整

  const handleScroll = () => {
    const scrollY = window.scrollY;
    
    // 【A】親枠（bgWrap）全体の表示・非表示の判定 (is-show)
    const rect = mainContent.getBoundingClientRect();
    const contentTop = rect.top + scrollY;
    const contentBottom = rect.bottom + scrollY - BG_END_OFFSET;
    const scrollBottom = scrollY + window.innerHeight;

    // ▼▼ ここをナビゲーションと完全に同じ条件に修正しました！ ▼▼
    const isVisible = (scrollY >= contentTop && scrollBottom <= contentBottom);
    bgWrap.classList.toggle('is-show', isVisible);


    // 【B】中の画像の切り替え判定 (is-active)
    let activeId = null;

    bgImages.forEach((img) => {
      const targetId = img.getAttribute('data-id');
      if (!targetId) return;

      const targetSection = document.querySelector(targetId);
      if (targetSection) {
        const sectionRect = targetSection.getBoundingClientRect();

        // セクションの頭が画面の中央より上に来たら、それを現在地とする
        if (sectionRect.top <= triggerLine) {
          activeId = targetId;
        }
      }
    });

    // 画像のクラス付け替え処理
    let isActiveFound = false;
    bgImages.forEach((img) => {
      if (img.getAttribute('data-id') === activeId) {
        img.classList.add('is-active');
        isActiveFound = true;
      } else {
        img.classList.remove('is-active');
      }
    });

    // どのセクションもまだ画面中央まで来ていない時は1枚目を強制表示
    if (!isActiveFound && bgImages.length > 0) {
      bgImages.forEach(img => img.classList.remove('is-active'));
      bgImages[0].classList.add('is-active');
    }
  };

  // スクロール時と読み込み時に実行
  window.addEventListener('scroll', handleScroll);
  handleScroll();
});